<template>
    <div class="mt-6 content">
        <h3 class="has-text-white"><i class="fad fa-fw fa-clipboard-list-check mr-3"></i>Study Log</h3>

        <div class="mt-6 pb-6">
            <ui-card class="pt-0 pl-4 pr-6">
                <div class="content mt-3 pb-3 mr-6">
                    <p>Below is your <strong><i class="far fa-clipboard-list-check mr-2 ml-1"></i>Study Log</strong> used to record the automatically recorded time spent in the online course and other qualifying activities. This log represents the truthful and accurate account of the activities you completed for this course. It will be used to determine what certifications you quality for.</p>
                    <p>Access lessons for this course from
                        <router-link :to="{name: 'course-outline'}"><strong><i class="far fa-rectangle-list mr-2 ml-1"></i>Course Outline</strong></router-link>
                        or, if available, record offline time and other qualifying actives to contribute to the log.
                    </p>
                </div>
                <hr class=""/>

                <!--                <json-viewer :value="enrollment.study_log"></json-viewer>-->
                <!--                <json-viewer :value="studyLog"></json-viewer>-->

                <table class="table">
                    <template v-for="row in studyLog">
                        <tr class="log-row">
                            <template>
                                <td style="width: 10px;">
                                    <b-tag type="is-success" style="width: 100%; justify-content: left;"><i class="fas fa-check fa-fw mr-2"></i><strong class="has-text-white">{{ row.totalmins }}</strong> Minute<span v-if="row.totalmins !== 1">s</span></b-tag>
                                </td>
                                <td>
                                    <div class="log-title">{{ row.date | moment('dddd, MMMM Do, YYYY') }}</div>

                                    <template v-if="row.entries.length === 1">
                                        <div class="is-size-7 mt-2" v-if="getComponent(row.component_id)"><i class="far fa-fw fa-location-dot mr-1"></i>{{ getComponent(row.component_id).title }}</div>
                                        <div class="is-size-7 has-text-grey"><i class="far fa-fw fa-clock mr-1"></i>{{ displayDates(row.start_date, row.end_date) }}</div>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <div class="log-date is-clickable" @click="row.showEntries = !row.showEntries">
                                                <i class="fas fa-fw mr-1" :class="{'fa-chevron-down': row.showEntries, 'fa-chevron-right': !row.showEntries}"></i>
                                                {{ row.entries.length }} Records
                                            </div>

                                            <div class="mb-5" v-if="row.showEntries">
                                                <div class="log-date" v-for="entry in row.entries">
                                                    <div class="is-size-7 mt-2" v-if="getComponent(entry.component_id)"><i class="far fa-fw fa-location-dot mr-1"></i>{{ getComponent(entry.component_id).title }}</div>
                                                    <div class="is-size-7 has-text-grey">
                                                        <i class="far fa-fw fa-clock mr-1"></i>{{ displayTimes(entry.start_date, entry.end_date) }} ({{ entry.mins }} active min)
<!--                                                        <span class="ml-3 has-text-warning is-clickable" @click="removeChildLog(row, entry)"><i class="fas fa-fw fa-times mr-1"></i>Remove Entry</span>-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </td>
<!--                                <td class="has-text-right" style="width: 10px;" v-if="row.entries.length === 1">-->
<!--                                    <b-button expanded outlined type="is-warning" @click="removeLog(row)">-->
<!--                                        <i class="fas fa-fw fa-times mr-2"></i>Remove Entry-->
<!--                                    </b-button>-->
<!--                                </td>-->
<!--                                <td v-else></td>-->
                            </template>
                        </tr>
                    </template>
                </table>

                <hr/>

                <div><i class="fad fa-clock fa-fw mr-2 has-text-success"></i><strong>{{totalTime}}</strong> Total Time Recorded</div>

            </ui-card>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {client as http} from "../../http_client";
    import moment from "moment";
    import UiCard from "../../components/UiCard";
    import {mapActions, mapGetters} from "vuex";


    export default {
        components: {UiCard},
        props: ['enrollmentId'],
        data: function() {
            return {
                studyLog: []
            };
        },
        computed: {
            ...mapGetters(['enrollment']),
            totalTime: function() {
                let total = this.studyLog.reduce((acc, log) => acc + log.totalmins, 0);
                return moment.utc(total * 60 * 1000).format('HH:mm');
            },
        },
        methods: {
            ...mapActions(['getEnrollmentById']),
            logBuilder: function() {
                this.enrollment.study_log.forEach((entry) => {
                    let date = moment(entry.start_date).format('YYYY-MM-DD');
                    let existing = this.studyLog.find(l => l.date === date);
                    if (existing) {
                        existing.entries.push(entry);
                    } else {
                        this.studyLog.push({
                            date: date,
                            entries: [entry],
                            start_date: entry.start_date,
                            end_date: entry.end_date,
                            component_id: entry.component_id,
                            showEntries: entry.showEntries
                        });
                    }
                });

                this.studyLog.forEach((l) => {
                    l.totalmins = l.entries.reduce((acc, entry) => acc + entry.mins, 0);
                });
            },
            removeChildLog: function(parent, child) {
                console.log('remove child log', parent, child);
            },
            removeLog: function(log) {
                console.log('remove log', log);
            },
            getComponent(id) {
                let component = null;
                this.enrollment.course.outline.forEach((section) => {
                    section.components.forEach((c) => {
                        if (c.component_id === id) {
                            component = c;
                        }
                    });
                });
                return component;
            },
            displayDates: function(start, end) {
                let s = moment(start);
                let e = moment(end);
                if (s.isSame(e, 'day')) {
                    return s.format('dddd, MMMM Do, YYYY, h:mm A') + ' - ' + e.format('h:mm A');
                } else {
                    return s.format('MMM Do, YYYY, h:mm A') + ' - ' + e.format('MMM Do, YYYY, h:mm A');
                }
            },
            displayTimes: function(start, end) {
                let s = moment(start);
                let e = moment(end);
                if (s.isSame(e, 'day')) {
                    return s.format('h:mm A') + ' - ' + e.format('h:mm A');
                } else {
                    return s.format('MMM Do, YYYY, h:mm A') + ' - ' + e.format('MMM Do, YYYY, h:mm A');
                }
            }
        },
        mounted() {
            this.getEnrollmentById(this.enrollmentId).then(() => {
                this.logBuilder();
            });
        }
    };
</script>

<style lang="scss" scoped>
    .log-row {

        .log-title {
            margin-top: 2px;
            font-size: 1em;
            font-weight: bold;
        }

        .log-date {
            margin-top: 5px;
            font-size: 0.8em;
        }

        td {
            border-color: #eaeaea;
            padding: 15px 10px;
        }

        &:last-child td {
            border: none;
        }
    }
</style>
